import type { ReactNode } from 'react';

import type { DateInput } from '@repo/common';
import { DataTestIds } from '@repo/frontend-shared';

import { CalendarMonthAndYearPicker } from '../CalendarMonthAndYearPicker/CalendarMonthAndYearPicker';
import { MonthlyCalendarDaysGrid } from './MonthlyCalendarDaysGrid/MonthlyCalendarDaysGrid';
import { MonthlyCalendarWeekdayLabels } from './MonthlyCalendarWeekdayLabels/MonthlyCalendarWeekdayLabels';

import './MonthlyCalendar.scss';

interface MonthlyCalendarProps {
  onHeaderClick: () => void;
  onDateSelect: (date: DateInput) => void;
  allowPastDates?: boolean;
  renderDayMarker?: (day: Date) => ReactNode;
}

export function MonthlyCalendar({
  onHeaderClick,
  onDateSelect,
  allowPastDates,
  renderDayMarker,
}: MonthlyCalendarProps) {
  return (
    <div className="MonthlyCalendar" data-testid={DataTestIds.COMMON.SMALL_CALENDAR}>
      <div className="MonthlyCalendar__top-content">
        <CalendarMonthAndYearPicker onClick={onHeaderClick} labelType="body-large-bold" />
        <MonthlyCalendarWeekdayLabels />
        <MonthlyCalendarDaysGrid
          onDateSelect={onDateSelect}
          allowPastDates={allowPastDates}
          renderDayMarker={renderDayMarker}
        />
      </div>
    </div>
  );
}
